import React from 'react';
import PropTypes from 'prop-types';
import SignatureCanvas from 'react-signature-canvas';

export default class SignatureCreator extends React.Component {
  static clearInput() {
    const sigText = document.getElementById('sig-text');
    if (sigText) {
      sigText.value = '';
    }
  }

  static enableAddSignature() {
    const addSigBtn = document.querySelector('.signature-manager-container button.btn-large.save-use-btn');
    if (addSigBtn) {
      addSigBtn.classList.remove('disabled');
    }
  }

  constructor(props) {
    super(props);
    this.displayToolbox = this.displayToolbox.bind(this);
    this.clearCanvas = this.clearCanvas.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.visible) {
      SignatureCreator.clearInput();
      this.clearCanvas();
    }
  }

  componentDidUpdate() {
    if (this.props.visible && this.props.type === 'type') {
      this.typeCreator.focus();
    }
  }

  displayToolbox(type) {
    if (this.props.type === type && this.props.visible) {
      return { display: 'block' };
    }
    return { display: 'none' };
  }

  clearCanvas() {
    this.sigCanvas.clear();
  }

  saveCanvas() {
    return this.sigCanvas.getTrimmedCanvas().toDataURL();
  }

  render() {
    const sigPadClass = this.props.isTouchDevice ? 'signature-pad touch-device' : 'signature-pad';
    const canvasProperties = {
      className: 'pad sig-draw-pad',
      height: this.props.sigPadHeight,
      id: 'sig-draw-pad',
      width: this.props.sigPadWidth,

      style: {
        boxShadow: 'none',
      },
    };

    return (
      <div>
        <div id="sig-type-toolbox" className="sig-type-toolbox" style={this.displayToolbox('type')}>
          <label htmlFor="sig-text">{this.props.typeLabel}</label>
          <input
            type="text"
            name="sig-text"
            id="sig-text"
            className="sig-text"
            maxLength="35"
            ref={(input) => { this.typeCreator = input; }}
            onKeyPress={SignatureCreator.enableAddSignature}
          />
          <div className="sig-marker">X</div>
          <div className="teaxarea-triangle" />
        </div>
        <div id="sig-draw-toolbox" className="sig-draw-toolbox" style={this.displayToolbox('draw')}>
          <p className="signature-label">{this.props.drawLabel}</p>
          <div
            className={sigPadClass}
            onMouseUp={SignatureCreator.enableAddSignature}
          >
            <SignatureCanvas
              velocityFilterWeight={0.7}
              minWidth={0.5}
              maxWidth={2}
              dotSize={1.25}
              ref={(canvas) => { this.sigCanvas = canvas; }}
              canvasProps={canvasProperties}
            />
          </div>
          <a
            href="#clear"
            className="clear-button btn btn-mini"
            role="button"
            onClick={this.clearCanvas}
          >{this.props.clearBtnText}</a>
          <div className="teaxarea-triangle" />
        </div>
      </div>
    );
  }
}

SignatureCreator.propTypes = {
  visible: PropTypes.bool.isRequired,
  isTouchDevice: PropTypes.bool,
  type: PropTypes.string,
  typeLabel: PropTypes.string,
  drawLabel: PropTypes.string,
  clearBtnText: PropTypes.string,
  sigPadHeight: PropTypes.number,
  sigPadWidth: PropTypes.number,
};

SignatureCreator.defaultProps = {
  isTouchDevice: false,
  type: null,
  typeLabel: null,
  drawLabel: null,
  clearBtnText: 'Clear',
  sigPadHeight: 0,
  sigPadWidth: 0,
};



// WEBPACK FOOTER //
// ./src-react/SignatureManager/SignatureCreator.jsx